import { useContext, createContext } from "react";
import { ISocketService } from "../../../store/services";

export const SocketContext = createContext<ISocketService>(
  {} as ISocketService
);
export const useSocket = (): ISocketService =>
  useContext<ISocketService>(SocketContext);
